import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

const stripePromise = loadStripe(
  "pk_live_51S7mM8IchBxOMSrNMZr1Jd9bVRw8qtjvS2gyJsPCSYJYcJmxQRmXSKO9iOxpXua2NV1otWhZ84uf9kChvo621ytf00Bid9OLXE"
);
// pk_test_51PtRZYP0Bexf1JWIM9FK0AJR5iOkyQPUCb11T8Le76jb9nGHnNCQ2nPWcE0BJrjNm9W6zjrx0R1nNSBChIdtHQbS008IxWo80E
// pk_live_51S7mM8IchBxOMSrNMZr1Jd9bVRw8qtjvS2gyJsPCSYJYcJmxQRmXSKO9iOxpXua2NV1otWhZ84uf9kChvo621ytf00Bid9OLXE
const StripeProvider = ({ children }) => {
  return <Elements stripe={stripePromise}>{children}</Elements>;
};

export default StripeProvider;
